import { render, staticRenderFns } from "./media-dialog.vue?vue&type=template&id=40f4e7a1"
import script from "./media-dialog.vue?vue&type=script&lang=js"
export * from "./media-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f4e7a1')) {
      api.createRecord('40f4e7a1', component.options)
    } else {
      api.reload('40f4e7a1', component.options)
    }
    module.hot.accept("./media-dialog.vue?vue&type=template&id=40f4e7a1", function () {
      api.rerender('40f4e7a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/media-dialog.vue"
export default component.exports